import { useEffect, useRef } from "react";

const useDidMount = (callback: () => any) => {
  const hasMountedRef = useRef(false);

  useEffect(() => {
    if (hasMountedRef.current) return;
    callback();
    hasMountedRef.current = true;
    // eslint-disable-next-line
  }, []);
};

export default useDidMount;
